<script setup lang="ts">
import { AppText } from '@shared/ui/typography'
import { CardAdmin } from '@shared/ui/cards'

import { useTutorKanbanStore } from '../model/store'
import TimeOffItem from './time-off/TimeOffItem.vue'

defineOptions({
  name: 'TimeOffs',
})

const tutorKanbanStore = useTutorKanbanStore()
</script>

<template>
  <CardAdmin title="Time offs">
    <div
      v-if="tutorKanbanStore.getTimeOffs.length"
      class="time-offs"
    >
      <TimeOffItem
        v-for="timeOff in tutorKanbanStore.getTimeOffs"
        :key="timeOff.id"
        :time-off="timeOff"
      />
    </div>
    <AppText
      v-else
      name="body1"
      color="slate-500"
    >
      No time offs
    </AppText>
  </CardAdmin>
</template>

<style scoped lang="scss" src="./TimeOffs.scss" />
